import { AvailableCountryCodes } from "../typings/CountryCode";
import Feature from "src/js/stores/user/Feature";
import { Letter } from "src/js/stores/letter/store";
import { PaperFormat } from "../typings/PaperFormat";
import { Recipient } from "../typings/Recipient";
import { SiteLetterInput } from "../typings/Letter";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { toUserImageDTO } from "./toUserImageDTO";

export type TemplateInput = {
  letter: Letter;
  letterName: string;
  pageCount: number;
  siteBoundaryImage?: string;
};

export function toCreateLetterContentDTO(
  { letter, letterName, pageCount, siteBoundaryImage }: TemplateInput,
  recipient: Omit<Recipient, "siteBoundaryImageUrl">,
  options?: {
    hideRecipientAddress?: boolean;
    paperFormat?: PaperFormat;
  }
): SiteLetterInput {
  const usAccess = hasFeature(Feature.usAccess);
  const defaultPaperFormat = usAccess ? PaperFormat.US_LETTER : PaperFormat.A4;
  const defaultCountryCode = usAccess ? AvailableCountryCodes.UNITED_STATES : AvailableCountryCodes.UNITED_KINGDOM;

  return {
    letter: {
      ...letter,
      logo: toUserImageDTO(letter.logo),
      signature: toUserImageDTO(letter.signature),
    },
    letterName,
    pageCount,
    siteBoundaryImage,
    recipient: {
      ...recipient,
      // explicitly setting region here as it is required for backend to process the letter
      region: recipient.region ?? "",
      title: usAccess ? undefined : recipient.title,
      countryCode: recipient.countryCode ?? defaultCountryCode,
    },
    options: {
      ...options,
      paperFormat: options?.paperFormat ?? defaultPaperFormat,
    },
  };
}
